import _asyncToGenerator from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _get from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/get.js";
import _inherits from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { get as _get2, isEmpty, isString } from 'lodash';
import BaseSessionHandler from './base';

var ServerSessionHandler = /*#__PURE__*/function (_BaseSessionHandler) {
  _inherits(ServerSessionHandler, _BaseSessionHandler);

  var _super = _createSuper(ServerSessionHandler);

  function ServerSessionHandler() {
    _classCallCheck(this, ServerSessionHandler);

    return _super.apply(this, arguments);
  }

  _createClass(ServerSessionHandler, [{
    key: "get",
    value: function () {
      var _get3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var cookieCreds;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                cookieCreds = _get2(this.requestCookies, this.credsKey(), {});

                if (isString(cookieCreds) && cookieCreds !== 'undefined') {
                  try {
                    cookieCreds = JSON.parse(cookieCreds);
                  } catch (err) {
                    cookieCreds = {};
                  }
                }

                if (isEmpty(cookieCreds)) {
                  _context.next = 6;
                  break;
                }

                _context.next = 5;
                return this.set(cookieCreds);

              case 5:
                this.requestCookies = null;

              case 6:
                return _context.abrupt("return", _get(_getPrototypeOf(ServerSessionHandler.prototype), "get", this).call(this));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function get() {
        return _get3.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "set",
    value: function () {
      var _set = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(creds) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setResponseCookie(this.credsKey(), creds);
                _context2.next = 3;
                return _get(_getPrototypeOf(ServerSessionHandler.prototype), "set", this).call(this, creds);

              case 3:
                return _context2.abrupt("return", Promise.resolve());

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function set(_x) {
        return _set.apply(this, arguments);
      }

      return set;
    }()
  }, {
    key: "clear",
    value: function () {
      var _clear = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.clearResponseCookie(this.credsKey());
                return _context3.abrupt("return", _get(_getPrototypeOf(ServerSessionHandler.prototype), "clear", this).call(this));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function clear() {
        return _clear.apply(this, arguments);
      }

      return clear;
    }()
  }, {
    key: "persistThroughRedirect",
    value: function persistThroughRedirect(state) {
      this.setResponseCookie('redirectedAuthState', state);
    }
  }, {
    key: "loadAfterRedirect",
    value: function loadAfterRedirect() {
      this.clearResponseCookie('redirectedAuthState');
      return _get2(this.requestCookies, 'redirectedAuthState');
    }
  }]);

  return ServerSessionHandler;
}(BaseSessionHandler);

export { ServerSessionHandler as default };